export default __webpack_public_path__ + "static/orsusecase4-75ae851c373901c856a2fb101152d902.jpg";